const PROJECT_ROLES = Object.freeze({
  CUSTOMER_PROGRAM_MANAGER: 'Customer Program Manager',
  ACCOUNT_APPLICATIONS_ENGINEER: 'Account Applications Engineer',
  APPLICATIONS_ENGINEERING_MANAGER: 'Applications Engineering Manager',
  FIELD_APPLICATIONS_ENGINEER: 'Field Applications Engineer',
  ACCOUNT_MANAGER: 'Account Manager',
  CUSTOMER_PROGRAM_DIRECTOR: 'Customer Program Director',
  OBSERVER: 'Observer'
})

const PRODUCT_ROLES = Object.freeze({
  APPLICATIONS_ENGINEERING_DIRECTOR: 'Applications Engineering Director',
  PRODUCT_APPLICATIONS_ENGINEER: 'Product Applications Engineer',
  PRODUCT_MANAGER: 'Product Manager',
  SOFTWARE_PROGRAM_MANAGER: 'Software Program Manager',
})

const GLOBAL_ROLES = Object.freeze({
  LIMITED_ACCESS: 'Limited Access',
  FULL_ACCESS: 'Full Access',
  ADMIN_ACCESS: 'Admin Access',
  CLIENT_ACCESS: 'Client Access'
})

const ROUTE_ROLES = Object.freeze({
  PROJECT_CREATE: 'Project Roles Create',
  DATA_MANAGER: 'Data Manager Role'
})

export {
  PROJECT_ROLES,
  PRODUCT_ROLES,
  GLOBAL_ROLES,
  ROUTE_ROLES
}
